<template>
  <div class="tw-rounded tw-text-left tw-bg-white tw-shadow-xl tw-min-h-96 tw-flex tw-overflow-hidden tw-text-xl" style="height:75vh !important;">
    <div class="tw-w-36 lg:tw-w-1/3 tw-max-w-136 tw-border-r tw-border-gray-200 tw-divide-y tw-divide-gray-100 tw-overflow-auto">

      <div v-if="states.loading_chats" class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
        <div>Loading..</div>
      </div>
      <template v-else>

        <input v-model="states.search" type="text" class="tw-p-6 tw-border-b tw-w-full tw-rounded-none" placeholder="Search Chats..">

        <list-item
          v-for="chat in sortedChats" :isActive="chat.id === _.get(states.activeChat,'id')"
          :user="user" :chat="chat" :key="chat.id" v-on:click.native="store.selectChat(chat)"
        />

      </template>

    </div>

    <div v-if="states.activeChat === null" class="tw-w-2/3 tw-flex tw-items-center tw-justify-center">
      <div class="tw-text-gray-600 text-text-6xl">Select A Chat</div>
    </div>

    <conversation v-else/>

  </div>
</template>
<script>
  import _ from 'lodash'
  import ListItem from "./messenger-list-item"
  import Conversation from './messenger-conversation'
  import store from './messenger-store'

  export default {
    components: {
      ListItem,
      Conversation,
    },
    props: {
      user: {}
    },
    data: v => ({
      states: store.states
    }),
    created() {
      this.store = store
      store.states.user = this.user
      store.getChats().then(() => {
        store.joinUserChannel()
        store.joinInitialChat()
      })
      store.registerTypingIntervals()
    },
    computed: {
      sortedChats() {
        return _.chain(this.states.chats)
          .filter(chat => chat.title.toLowerCase().includes(store.states.search.toLowerCase()))
          .values()
          .orderBy('updated_at', 'desc')
          .value()
      }
    },
  }
</script>
